import React from "react";

const defaultExpertise = [
  { id: 1, subject: "Arithmetic", level: "Basic" },
  { id: 2, subject: "Algebral", level: "Basic" },
  { id: 3, subject: "Mental Math Techniques", level: "Basic" },
  { id: 4, subject: "Mathematical Problem Solving", level: "Basic" },
  { id: 5, subject: "Arithmetic", level: "Basic" },
  { id: 6, subject: "Estimation", level: "Basic" },
  { id: 7, subject: "Remedial Math Instruction", level: "Basic" },
  { id: 8, subject: "Arithmetic", level: "Basic" },
  { id: 9, subject: "Arithmetic", level: "Basic" },
  { id: 10, subject: "Arithmetic", level: "Basic" },
  { id: 11, subject: "Arithmetic", level: "Basic" },
  { id: 12, subject: "Arithmetic", level: "Basic" },
  { id: 13, subject: "Arithmetic", level: "Basic" },
  { id: 14, subject: "Geometry", level: "Basic" },
  { id: 15, subject: "MentalMath", level: "Basic" },
];

const ExpertiseTag = ({ subject, level }) => (
  <span className="inline-flex items-center gap-1.5 rounded-full bg-[#923D8C0F] px-2.5 py-1 text-base leading-[19px]">
    <span className="text-[#923D8C]">{subject}</span>
    <span className="text-[#923D8C]">|</span>
    <span className="text-[#938A96]">{level}</span>
  </span>
);

const InstructorExpertise = ({ expertise = defaultExpertise }) => {
  return (
    <section className="rounded-xl border border-[#60555557] bg-white px-4 pb-6 pt-[13px] ">
      <h3 className="text-xl font-medium leading-[23px] text-black">Expertise</h3>

      <div className="mt-[17px] flex flex-wrap gap-[11px]">
        {expertise.map((item) => (
          <ExpertiseTag
            key={item.id}
            subject={item.subject}
            level={item.level}
          />
        ))}
      </div>
    </section>
  );
};

export default InstructorExpertise;
